module.exports = __webpack_public_path__ + "fb2bd0cddfefd0c5f798f0b4630d76cd.jpg";